import React from "react";
import PropTypes from "prop-types";
import { getString } from "../../utilities";

export default function Control({ isActive, className, label, icon, clickFunc, isDisabled }) {
  const activeStyle = isActive ? "active" : "";
  const controlStyle = className || "";
  const id = label.toLowerCase();

  return (
    <div className="control">
      <label htmlFor={id}>{label}</label>
      <button
        type="button"
        id={id}
        disabled={isDisabled}
        className={`control-button ${activeStyle} ${controlStyle}`}
        onClick={clickFunc}
      >
        {isActive ? getString("on.0") : getString("off.0")}
        {isActive ? icon.active : icon.inactive || icon.active}
      </button>
    </div>
  );
}

Control.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  className: PropTypes.string,
  icon: PropTypes.object.isRequired,
  clickFunc: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

Control.defaultProps = {
  className: undefined,
};
